<mat-sidenav-container>
  <mat-sidenav  #searchMenu 
                mode="side" 
                [opened]="status().isFilterSortOpen">
    <kbm-filter-sort [(filterSet)]="sortFilterSet" (filterSetChange)="resetPage()"/>
  </mat-sidenav>
  <mat-sidenav-content class="books" > 
    <kbm-loading></kbm-loading>
    <div class="books-header">
      <kbm-books-header 
              [setCount]="setCount()" 
              [totalCount]="totalBookCount()"
              (toggleSearch)="status().isFilterSortOpen" 
              [status]="status()"  
              (pageEvent)="onPageChange($event)"
              (isGridLayout)="toggleLayout($event)" />
    </div>
    <div>
      @if(isLoggedIn() && ! status().isGridLayout) {
      <div class="book-batch">
        <kbm-books-list [books]="books()"></kbm-books-list>
      </div>
      }
      @else {
      <div class="book-cards">
        <kbm-books-grid [books]="books()"></kbm-books-grid>
      </div>
      }
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<!-- <ng-template #loading class="loading-shade">

  <p>Just a sec ...</p>
  <img src="../../../assets/busy.gif">
</ng-template> -->
<!--   P o p o v e r   C o n t e n t s   T e m p l a t e   -->
<!-- <ng-template #popContent>
  <div>
    {{b.title}} 
  </div>
  <div class="popoverDetails book-item-popover"><span class="popoverYear book-item-popover">{{book.authors}}</span>
    <div class="popoverDescription book-item-popover"> {{item.description}}</div>
    <span class="popoverLabel book-item-popover"> Rating:</span> {{item.rating}}
    <br> <span class="popoverLabel book-item-popover"> Release Date:</span> {{item.releaseDate > '0000-00-00' ?
    item.releaseDate : item.year}}
    <br> <span class="popoverLabel book-item-popover"> Item Type:</span> {{item.bookItemTypeDesc}}
  </div>
</ng-template>
-->